import { render, staticRenderFns } from "./ParentGuardian.vue?vue&type=template&id=3ac983e7"
import script from "./ParentGuardian.vue?vue&type=script&lang=js"
export * from "./ParentGuardian.vue?vue&type=script&lang=js"
import style0 from "./ParentGuardian.vue?vue&type=style&index=0&id=3ac983e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports